import { TRESPONSE_ORDER_ALLOCATION_CARD_DATA } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableFooterNode, TTableOptions } from '../../table.type';

type TAllocatedData = Extract<TRESPONSE_ORDER_ALLOCATION_CARD_DATA, { allocated: true }>;

const createHeaderRow = (
  headerInfo: TAllocatedData['header_info'],
  isEditDisabled: boolean,
): TTableOptions['headerConfig'] => {
  return [
    ...headerInfo.map((hInfo): TTableOptions['headerConfig'][number] => ({
      type: 'TEXT_CELL' as const,
      text: hInfo.display_name,
    })),
    ...(isEditDisabled ? [] : [{ type: 'EMPTY_CELL' as const }]),
  ];
};

const createFooterRow = (
  headerInfo: TAllocatedData['header_info'],
  totalsRow: TAllocatedData['total_quantities'],
  isEditDisabled: boolean,
): TTableFooterNode['cells'] => {
  return [
    ...headerInfo.map((hInfo): TTableFooterNode['cells'][number] => ({
      type: 'TEXT_CELL',
      text: totalsRow[hInfo.key],
    })),
    ...(isEditDisabled ? [] : [{ type: 'EMPTY_CELL' as const }]),
  ];
};

const getRows = (
  headerInfo: TAllocatedData['header_info'],
  rowItem: TAllocatedData['orders'][number],
  isEditDisabled: boolean,
): TTableCellTree[] => {
  return [
    ...headerInfo.map((hInfo) => ({
      type: 'TEXT_CELL' as const,
      text: rowItem[hInfo.key],
    })),
    ...(isEditDisabled ? [] : [{ type: 'ACTION_CELL' as const, actionType: 'DELETE' as const, asIcon: true }]),
  ];
};

export const ALLOCATION_CARD_TABLE_MODEL = {
  createModel: (allocationDetails: TAllocatedData, isEditDisabled: boolean) => {
    return ModifiersZTableModel.createTableModel(
      allocationDetails.orders,
      {
        padding: 8,
        headerConfig: createHeaderRow(allocationDetails.header_info, isEditDisabled),
        footerConfig: createFooterRow(
          allocationDetails.header_info,
          allocationDetails.total_quantities,
          isEditDisabled,
        ),
      },
      (item) => ({
        type: 'ROW',
        rowItem: item,
        cells: getRows(allocationDetails.header_info, item, isEditDisabled),
      }),
    );
  },
};
